import { useTranslation } from 'react-i18next'
import { SendVerificationResponse, usePostSiteSendVerificationEmailMutation } from '../../../api'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { IconPaperAirplane } from '../../../../shared/components/icons/IconPaperAirplane'
import { useAppDispatch, useAppSelector } from '../../../store/hooks/Redux'
import { showAlert } from '../../../store/reducers/AppSlice'
import { selectUser } from '../../../store/reducers/AuthSlice'

/** Просьба подтвердить email: не показываем админам и в режиме имперсонации */
export const EmailVerifyBar = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const user = useAppSelector(selectUser)

  const [sendVerification] = usePostSiteSendVerificationEmailMutation()

  if (user.is_email_verified || user.role === 'admin' || user.is_virtual_mode) return null

  return (
    <div className={'w-full bg-default'}>
      <div className={'mx-auto px-[16px] md:container xl:max-w-[1440px] xxl:max-w-[1920px]'}>
        <div className={'flex items-center gap-[4px] py-[6px]'}>
          <p className={'text-white'}>{t('other.confirmYourEmail')}</p>
          <BpButton
            className={'!p-0 hover:opacity-[0.8]'}
            contentClassName={'!text-white border-b-[#FFFFFF66] border-b-[1px] border-dashed'}
            iconLeft={<IconPaperAirplane />}
            size={'sm'}
            theme={'transparent'}
            onClick={() => {
              sendVerification()
                .unwrap()
                .then((response) => {
                  if (response.success) {
                    dispatch(
                      showAlert({
                        message: (response as SendVerificationResponse).data?.message ?? '',
                        type: 'success',
                        timeout: 2000,
                      }),
                    )
                  }
                })
                .catch(() => undefined)
            }}
          >
            {t('buttons.resendConfirmationLink')}
          </BpButton>
        </div>
      </div>
    </div>
  )
}
